import { api, download } from "api/Call";
import { cachedData, setCachedData } from "./Cache";
import ApiUtils from "api/Utils";
import { config } from "config";
import EventsEmitter from "events/EventsEmitter";
import { org,defaultThumbnailIcon } from "constants/common";
import { BroadcastChannel } from 'broadcast-channel';

//const org = localStorage.getItem('organizationID');

//console.log("ORG ID : " + org)
let processed = 0;
let projectsCount = 0;
const views: any = {};

const attributeFilters: any = [
    "name",
    "comment",
    "entity_container",
    "error_info",
    "file_type",
    "file_date",
    "file_folder",
    "has_thumbnail",
    "program_type",
    "state",
    "type",
    "version_label",
    "version_number",
    "version_active",
    "version_active_date",
    "capture_date",
    "view_type",
    "user",
    "virtual",
    "workflow",
    "workflow_product",
];

export const getData = (force?: boolean) =>
    new Promise((resolve) => {
        console.log("getData...");
        console.time("getData");
        if (Object.keys(cachedData.projects).length === 0 || force) {
            if (force || !cachedData.cachedLoaded) {
                let url = config.api.endpoints["entity"];
                fetchData(url).then((result: any) => {
                    setCachedData(result);

                    console.log('Result : ' + result)
                    console.timeEnd("getData");
                    resolve(cachedData);
                });
            } else {
                resolve(cachedData);
            }
        } else {
            resolve(cachedData);
        }
    });

const fetchData = (url: string) =>
    new Promise((resolve, reject) => {
        api(url)
            .then((response: any) => {
                if (response.error || response.result === "error") {
                    if (response.message) {
                        const errorMessage: string = atob(response.message);
                        console.error(errorMessage);
                    }
                    EventsEmitter.emit("criticalError", {
                        message: "Error accessing data!",
                        redirect: true,
                    });
                    const curCachedData = { ...cachedData, ...response };
                    resolve(curCachedData);
                } else {
                    let projectsRef = Object.values(response).filter(
                        (entry: any) =>
                            entry["virtual"] !== "1" &&
                            entry["project_ref"] &&
                            entry["type"] === "PROJECT_REF" &&
                            entry["access_level"] !== "none"
                    );
                    console.log("projectsRef:", projectsRef);
                    console.log("isFilters:", config.api.filters);
                    if (projectsRef.length === 0) {
                        let newData = { ...cachedData, projectsRef, loaded: true };
                        setCachedData(newData);
                        resolve(newData);
                    } else {
                        //EventsEmitter.emit("projects_progress", 1);
                        fetchProjects(projectsRef, () => {
                            resolve(cachedData);
                        });
                    }
                }
            })
            .catch((error: any) => {
                console.error(error);
                reject(error);
            });
    });

const fetchProjects = async (projectsRef: any, callback: any) => {
    console.time("asyncForEachProject");
    let refPromises: any = [],
        projectPromises: any = [];
    const projects: any = {};
    const projectsIds = projectsRef.map((projectRef: any) => projectRef["project_ref"]);
    projectsIds.forEach((projectId: string) => {
        let promise = ApiUtils.getProject(projectId).then((result: any) => {
            if (result.ID) {
                projects[result.ID] = result;
            }
        });
        projectPromises.push(promise);
    });

    Promise.allSettled(projectPromises).then(() => {
        projectsCount = Object.keys(projects).length;
        console.log("projects Count:", projectsCount);
        console.log("projectsList:", projects);
        let projectsDone = 0;
        EventsEmitter.on("current_projects_progress", (value: number) => {
            if (projectsCount > 1) {
                if (value > 99) {
                    projectsDone++;
                }
                //console.log("projectsDone:", projectsDone);
                const doneValue: number = (projectsDone / projectsCount) * 100;
                const curValue: number = value / 100;
                const totalValue = doneValue + (projectsDone < projectsCount ? curValue : 0);
                //console.log("totalValue:", totalValue);
                EventsEmitter.emit("projects_progress", totalValue);
            } else {
                EventsEmitter.emit("projects_progress", value);
            }
        });
        Object.keys(projects).forEach((projectId: string) => {
            const data = projects[projectId];
            const promise = fetchViews(projectId, data);
            refPromises.push(promise);
        });
        return Promise.allSettled(refPromises).then((result: any) => {
            console.log("*****done retrieving remote projects");
            let newData = { ...cachedData, views, projects, projectsRef, loaded: true };
            setCachedData(newData);
            console.log("cachedData:", cachedData);

            const channel = new BroadcastChannel('cachedData');
            channel.postMessage({'cachedData' : cachedData});
            // channel.onmessage = data => console.dir(data.projects);

            callback();
            console.timeEnd("asyncForEachProject");
        });
    });
};

const fetchViews = (projectId: string, projectData: any) => {
    console.log(`getting ${projectId} data...`);
    return new Promise((resolve, reject) => {
        let url = config.api.endpoints["entity"] + "?project=" + projectId;
        if (Boolean(config.api.filters === "true")) {
            url += "&filter=" + attributeFilters.join(",");
        }
        return download(url)
            .then((data: any) => {
                if (data && data["result"] !== "error") {
                    processedData(projectId, projectData, data).then(() => {
                        console.log("done with:", processed, "projects|current:", projectId);
                        //EventsEmitter.emit("projects_progress", parseInt((processed * 100) / projectsCount + ""));
                        resolve(data);
                    });
                } else {
                    console.error(`Error for ${projectId}: ${atob(data["error_info"])}`);
                }
            })
            .catch((error: any) => {
                console.error(error);
                reject(error);
            });
    });
};

const processedData = (projectId: string, projectData: any, data: any) => {
    return new Promise((resolve) => {
        let entries = Object.entries(data);
        entries.forEach((entry: any) => {
            entry[1]["project"] = projectId;
            entry[1]["ID"] = entry[0];
        });
        //console.log(`data for ${projectId}:`, data);
        cachedData["entities"][projectId] = Object.fromEntries(entries);
        cachedData["entities"][projectId][projectId] = projectData;
        //console.log("cachedData:", cachedData);
        const currentProject = entries.find((entry: any) => entry[1].type === "PROJECT");
        if (currentProject) {
            const projectViews = entries.filter(
                (entry: any) => entry[1].file_type === "VIEW" && entry[1].view_type === "container"
            );
            //console.log("project:", project, "|projectViews:", projectViews);
            var viewsCount = projectViews.length;
            if (viewsCount === 0) {
                processed++;
                resolve({});
            } else {
                projectViews.forEach(async (view: any) => {
                    const description = "";
                    var newView = { ...view[1], description: description };
                    if (view[1].has_thumbnail === "1") {
                        const thumb: any = await fetchThumb(projectId, view[1].ID);
                        newView = { ...view[1], thumb: thumb };
                    } else {
                        newView = { ...view[1], thumb: defaultThumbnailIcon };
                    }
                    views[view[0]] = newView;
                    // console.log("asyncForEachView.views:", Object.values(views).length);
                    viewsCount--;

                    if (viewsCount === 0) {
                        processed++;
                        resolve(views);
                    }
                });
            }
        } else {
            processed++;
            resolve({});
        }
    });
};

/********************************
 *********************************
 */

export const fetchProjectEntities = (projectId: string, callback?: any) =>
    new Promise((resolve, reject) => {
        api("entity.ashx?project=" + projectId)
            .then((entries: any) => {
                if (callback) {
                    callback(entries);
                }
                resolve(entries);
            })
            .catch((error: any) => {
                console.error(error);
                reject(error);
            });
    });

export const fetchCustomColors = (project: string, id: string, done?: any) => {
    return new Promise((resolve, reject) => {
        const nameHint = "custom-colors.txt";
        const url =
            config.api.endpoints["file"] +
            "?org=" +
            org +
            "&project=" +
            project +
            "&id=" +
            id +
            "&filename=" +
            nameHint +
            "&namehint=" +
            btoa(nameHint);
        return api(url, { format: "text" })
            .then((data: any) => {
                done(data);
                resolve(data);
            })
            .catch((error: any) => {
                console.error(error);
                done(error);
                reject(error);
            });
    });
};

const fetchThumb = (project: string, id: string) => {
    return new Promise((resolve, reject) => {
        const nameHint = "thumbnail.txt";
        const url =
            config.api.endpoints["file"] +
            "?org=" +
            org +
            "&project=" +
            project +
            "&id=" +
            id +
            "&filename=" +
            nameHint +
            "&namehint=" +
            btoa(nameHint);
        return api(url, { format: "text" })
            .then((data: any) => {
                if (!data || data === "" || data?.indexOf("data:image/") === -1) {
                    data = defaultThumbnailIcon;
                }
                resolve(data);
            })
            .catch((error: any) => {
                console.error(error);
                reject(error);
            });
    });
};

export const fetchComments = (viewId: string) =>
    new Promise((resolve, reject) => {
        const url = config.api.endpoints["entity"] + "?project=comments:" + viewId;
        api(url)
            .then((entries: any) => {
                const result = Object.values(entries).filter((entry: any) => entry.type === "COMMENT");
                const comments: any = {};
                comments[viewId] = result;
                cachedData["comments"] = comments;
                //console.log("******update comments", cachedData["comments"]);
                resolve(result);
            })
            .catch((error: any) => {
                console.error(error);
                reject(error);
            });
    });

export const fetchSnapshots = (projectId: string, viewId: string) =>
    new Promise((resolve, reject) => {
        const url = config.api.endpoints["entity"] + "?project=slides:" + viewId;
        api(url)
            .then(async (entries: any) => {
                const slides: any = [];
                const result = Object.values(entries).filter((entry: any) => entry.type === "SLIDE") || [];
                let pending = result.length;
                result.map(async (snapshot: any) => {
                    const icon: any = await fetchThumb(projectId, snapshot.ID);
                    snapshot.icon = icon;
                    slides.push(snapshot);
                    pending--;
                    if (pending === 0) {
                        const snapshots: any = {};
                        snapshots[viewId] = slides;
                        cachedData["snapshots"] = snapshots;
                        resolve(result);
                    }
                });
            })
            .catch((error: any) => {
                console.error(error);
                reject(error);
            });
    });
